import React, {FC} from 'react';
import styled from 'styled-components';

import {useKeyboardContext} from '../keyboard/keyboardContext';
import {
  TextKeyboardShortcutsFormatter,
  TextKeyboardShortcutsFormatterProps,
} from '../keyboard/textKeyboardShortcutFormatter';

/*
 * Style.
 */

const StyledShortcutSpan = styled.span`
  color: ${(p) => p.theme.tooltip.textSecondary};
`;

/*
 * Component.
 */

export const TooltipShortcutFormatter: FC<TextKeyboardShortcutsFormatterProps> = (props) => {
  const keyboardContext = useKeyboardContext();
  const shortcuts = keyboardContext.mapping[props.action];
  if (shortcuts.length === 0) {
    return null;
  }

  return (
    <StyledShortcutSpan>
      <TextKeyboardShortcutsFormatter {...props} />
    </StyledShortcutSpan>
  );
};
